<template>
  <div>
    <el-form ref="form"  label-width="120px" label-position="left" class="tabcard">
      <el-form-item label="消息：">
        <el-input v-model="msginfo"></el-input>
        <el-button style="margin-top: 20px;" @click="sendmsg">发送消息</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'KafkaEx',
    data () {
      return {
        msginfo: ''
      }
    },
    mounted () {
      that = this
    },
    methods: {
      sendmsg () {
        var postdata = {
          msginfo: that.msginfo
        }
        that.$http({
          url: 'http://localhost:5205/producemsg',
          method: 'post',
          data: postdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/kafkaex/KafkaEx.vue